import { Component, h, Prop } from '@stencil/core';
import { htmlSanitizer } from '../../../utils/html-sanitizer';

@Component({
  tag: 'vsr-icon-card',
  styleUrl: 'vsr-icon-card.scss',
  shadow: false,
})
export class VsIconCard {
  @Prop() theme: 'light' | 'dark' = 'light';
  @Prop() title!: string;
  @Prop() titleHref?: string;
  @Prop() titleTarget: '_self' | '_blank' | '_parent' | '_top' = '_self';
  @Prop() description?: string;
  @Prop() buttonText?: string;
  @Prop() buttonHref?: string;
  @Prop() buttonTarget: '_self' | '_blank' | '_parent' | '_top' = '_self';
  @Prop() imgSrc?: string;
  @Prop() imgAlt: string = '';
  @Prop() imageAspectRatio: string = '1:1';

  private renderArrowIcon() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M1 8h9" />
        <polyline points="6 3 11 8 6 13" />
      </svg>
    );
  }
  render() {
    const hasLinkClass = this.titleHref ? 'has-card-link' : '';
    const aspectRatioClass = `aspect-ratio-${this.imageAspectRatio.replace(':', '-')}`;
    const is16by9 = this.imageAspectRatio === '16:9' ? 'no-hover-16-9' : '';
    return (
      <div
        class={`vsr-icon-card_container vsr-icon-card_container-${this.theme} ${hasLinkClass} ${is16by9}`}
      >
        {this.imgSrc && (
          <div class={`vsr-icon-card_image ${aspectRatioClass}`}>
            <img class="vsr-icon-card_img" src={this.imgSrc} alt={this.imgAlt} />
          </div>
        )}
        <div class="vsr-icon-card_info">
          {this.title &&
            (this.titleHref ? (
              <a
                href={this.titleHref}
                class="vsr-icon-card__title"
                target={this.titleTarget}
                innerHTML={htmlSanitizer(this.title)}
              />
            ) : (
              <div
                class="vsr-icon-card__title"
                innerHTML={htmlSanitizer(this.title)}
                tabindex="0"
              />
            ))}
          {this.description && (
            <div class="vsr-icon-card__description" innerHTML={htmlSanitizer(this.description)} />
          )}
          {this.buttonText && (
            <div class="vsr-icon-card__action-button">
              <a
                href={this.buttonHref}
                target={this.buttonTarget}
                class="vsr-icon-card__action-button_link quick-apply"
              >
                {this.buttonText} {this.renderArrowIcon()}
              </a>
            </div>
          )}
        </div>
      </div>
    );
  }
}
